export default {
    props: {
        width: {
            required: false,
            type: [Number, String],
            default: 13
        },

        height: {
            required: false,
            type: [Number, String],
            default: 13
        },

        color: {
            required: false,
            type: String,
            default: "currentColor"
        },

        hoverColor: {
            type: String,
            default: "currentColor"
        },

        disabled: {
            required: false,
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            disabledStateColor: "#B9B9B9",
            isHover: false
        };
    },

    computed: {
        fillColor() {
            if (this.disabled) {
                return this.disabledStateColor;
            }

            if (this.isHover) {
                return this.hoverColor;
            }

            return this.color;
        }
    }
};